import { render, staticRenderFns } from "./UserPasswordForm.vue?vue&type=template&id=1ec0260e&"
import script from "./UserPasswordForm.vue?vue&type=script&lang=js&"
export * from "./UserPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports